import { Button } from "../ui/button";
import useAnswerSideBar from "@/hooks/ai-agent/use-answer-side-bar";
import RightArrowIcon from "../ui/icons/RightArrowIcon";
import { Text } from "../ui/text";
import type { Reference } from "./message-list";
import type { AnswerSideBarItem } from "@/stores/answer-side-bar";

const PaperTitlesButton = ({
  references,
}: {
  references: Reference[];
}) => {
  const { handleAnswerSideBarOpen } = useAnswerSideBar();
  const items: AnswerSideBarItem[] = references.map((r) => ({
    id: r.reference_number,
    url: r.url,
    title: r.title,
    content: r.content,
  }));

  return (
    <Button
      variant={"gradation"}
      onClick={() => {
        handleAnswerSideBarOpen("paper-titles", items);
      }}
      className="h-[44px] rounded-[8px]"
    >
      <Text variant="body-regular" className="text-primary-0">
        View {references.length} paper titles
      </Text>
      <RightArrowIcon color="#027167" />
    </Button>
  );
};

export default PaperTitlesButton;
